import hubspot from './hubspot';
import salesforce from './salesforce';
import gmail from './gmail';
import googleCalendar from './google-calendar';
import slack from './slack';
import type { IntegrationProvider, ProviderKey } from './types';

const providers: Record<string, IntegrationProvider> = {
  hubspot,
  salesforce,
  gmail,
  'google-calendar': googleCalendar,
  slack,
};

export const getProvider = (key: ProviderKey): IntegrationProvider => providers[key] || providers.hubspot;

export type { IntegrationProvider, ProviderKey } from './types';
